import aikoutuIcon from '@/assets/img/icons/aikoutu.png'

export const iconStyle = {
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  backgroundColor: '#fff',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

export function AiKoutuIcon() {
  return (
    <div style={iconStyle}>
      <img src={aikoutuIcon} alt="ai抠图" />
    </div>
  )
}
import aikoutuIcon from '@/assets/img/icons/aikoutu.png'

export const iconStyle = {
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  backgroundColor: '#fff',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

export function AiKoutuIcon() {
  return (
    <div style={iconStyle}>
      <img src={aikoutuIcon} alt="ai抠图" />
    </div>
  )
}
